import React, { useState, useEffect, useRef } from 'react';

import CardEvent from '../CardEvent/CardEvent'; // Assumi che il percorso del componente CardEvent sia corretto
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  eventlist: {
    // marginLeft: 10,
    maxHeight: 'calc(90vh)', 
    overflowY: 'scroll', // Keep scrolling enabled but hide the scrollbar
    boxSizing: 'border-box',
    // Hide scrollbar for WebKit-based browsers (Chrome, Safari)
    '&::-webkit-scrollbar': {
      display: 'none',
    },

    // Hide scrollbar for Firefox
    scrollbarWidth: 'none', // Firefox only
    // This ensures the scrolling still works even though the scrollbar is hidden
    msOverflowStyle: 'none', // Internet Explorer 10+
  },
  highlightedCard: {
    backgroundColor: '#093F75',
  },
  title: {
    color: '#113e72', // Colore blu per il testo
    margin: theme.spacing(4, 0), // Aggiunge margine sopra e sotto il testo
    fontWeight: 'bold',
    fontSize:'16px',
    textTransform: 'uppercase',

  },
  cardSpacing: {
    marginBottom: '20px', // IMPORTANTE: Aggiunge uno spazio sotto ogni card. calcolato da template
    borderBottom: '0.8px solid #f0f0f0', // Linea divisoria ancora più leggera
    display:'flex',
    
  },

}));


const CardEventList = ({ eventi, onHighlight,triggerNextHighlight }) => {

  
      const classes = useStyles();
      //prima card: 0
      const [highlightedIndex, setHighlightedIndex] = useState(0);
      const containerRef = useRef(null);
      const cardRefs = useRef([]);

      // Function to sort events
  const sortEvents = (events) => {
    const now = new Date();

    return events.sort((a, b) => {
      const startA = new Date(a.data_inizio);
      const endA = new Date(a.data_fine);
      const startB = new Date(b.data_inizio);
      const endB = new Date(b.data_fine);

      // First, check if the events are finished
      const isFinishedA = endA < now;
      const isFinishedB = endB < now;

      if (isFinishedA && !isFinishedB) return 1;  // A is finished, B is not, so B comes first
      if (!isFinishedA && isFinishedB) return -1; // B is finished, A is not, so A comes first

      // If both are ongoing/upcoming, sort by the nearest start date
      return startA - startB;
    });
  };

      useEffect(() => {
        
        if (eventi.length > 0) {

          const sortedEvents = sortEvents(eventi);
          const updateHighlightedEvent = (index) => {
            const event = sortedEvents[index];
            // alert(index);
            onHighlight(event.nome_evento, event.data_inizio,event.data_fine,event.status, event.descrizione_evento,event.logo,event.sale);
          };

          if (triggerNextHighlight) {
            
            setHighlightedIndex(prevIndex => {
              
              const newIndex = (prevIndex + 1) % sortedEvents.length;
              // console.log('newindex' + newIndex);
              updateHighlightedEvent(newIndex);
              return newIndex;
            });
          } else {
            // alert('prima card')
            updateHighlightedEvent(highlightedIndex);
          }
        }
    }, [eventi.length,triggerNextHighlight ]);

    useEffect(() => {
      if (cardRefs.current[highlightedIndex] && containerRef.current) {
        const highlightedCard = cardRefs.current[highlightedIndex];
        const container = containerRef.current;
  
        // Scroll only the container, not the whole page
        const containerTop = container.scrollTop;
        const containerBottom = containerTop + container.offsetHeight;
        const cardTop = highlightedCard.offsetTop;
        const cardBottom = cardTop + highlightedCard.offsetHeight;
  
        // Extra padding to make sure the card is fully visible with some buffer
        const padding = 20;  // Scroll a bit more to make sure the full card is visible

        // Adjust scroll to fully show the card, with a little extra space (padding)
        if (cardTop < containerTop) {
          container.scrollTop = cardTop - padding;
        } else if (cardBottom > containerBottom) {
          container.scrollTop = cardBottom - container.offsetHeight + padding;
        }
      }
    }, [highlightedIndex]);


  return (
    // <div>
      <Container className={classes.eventlist}  ref={containerRef}>

      <div className={classes.title}>Eventi di Oggi</div>
      
 
        {eventi.length > 0 && eventi.map((event,index) => {
          return (
          <div key={index}  ref={(el) => (cardRefs.current[index] = el)} className={classes.cardSpacing}>
          <CardEvent
            key={index}
            logoSrc={event.logo}
            labels={event.sale}
            className={index === highlightedIndex ? classes.highlightedCard : ''}
            nome_evento={event.nome_evento}
            data_inizio={event.data_inizio}
            data_fine={event.data_fine}
            isHighlighted={index === highlightedIndex}
          />
          </div>
        )})} 

      </Container>
    
  );
};

export default CardEventList;
